<template>
  <section v-if="isSmartphoneCategory" ref="sectionRef">
    <header class="mb-24 md:mb-32 md:text-center">
      <h3 class="heading-3 mb-12">{{ i18n(translations.productFeature) }}</h3>
      <h4 class="punchline-sans">{{ i18n(translations.chooseCapacity) }}</h4>
    </header>

    <p class="body-1 mb-24 md:mb-32 md:text-center max-w-[760px] md:mx-auto">
      {{ i18n(translations.description) }}
    </p>

    <div class="grid grid-cols-1 gap-16 md:grid-cols-2">
      <div
        class="relative aspect-[3/2] md:aspect-auto overflow-hidden rounded-lg"
      >
        <RevIllustration
          alt=""
          class="h-full w-full object-cover md:absolute md:inset-0"
          :height="800"
          role="presentation"
          :src="illustration"
          :width="800"
        />
      </div>

      <div class="grid auto-rows-fr gap-16">
        <div
          v-for="tier in batteryTiers"
          :key="tier.title.id"
          class="rounded-lg border border-static-default-low bg-static-default-low px-24 py-16 flex flex-col justify-center"
        >
          <span class="text-static-default-hi heading-2">{{
            i18n(tier.title)
          }}</span>
          <p class="body-2 text-static-default-mid mt-8">
            {{ i18n(tier.description) }}
          </p>
        </div>
      </div>
    </div>

    <AboutBatteryModalUpdated :illustration :is-smartphone-category />
  </section>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'
import { useIntersectionObserver } from '@vueuse/core'

import { ProductCategory } from '~/scopes/product/constants'

import AboutBatteryModalUpdated from '../AboutBatteryModalUpdated/AboutBatteryModalUpdated.vue'

import translations from './AboutBatteryBlockUpdated.translations'

const { categoryId } = defineProps<{
  categoryId: string
}>()

const i18n = useI18n()

const { trackProductBlockImpression } = useTracking()

const sectionRef = ref<HTMLElement | null>()

const isSmartphoneCategory = computed(
  () => ProductCategory.SMARTPHONE === categoryId,
)

const illustration = '/img/product/jp/smartphone_battery.jpg'

const batteryTiers = [
  {
    title: translations.batteryTier1Title,
    description: translations.batteryTier1Description,
  },
  {
    title: translations.batteryTier2Title,
    description: translations.batteryTier2Description,
  },
  {
    title: translations.batteryTier3Title,
    description: translations.batteryTier3Description,
  },
]

const { stop } = useIntersectionObserver(sectionRef, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    trackProductBlockImpression({
      block_name: 'battery_block',
    })
    stop()
  }
})
</script>
